// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/transactional/datafeed/v1/entity.proto (package securities.transactional.datafeed.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum securities.transactional.datafeed.v1.Top20Type
 */
export const Top20Type = /*@__PURE__*/ proto3.makeEnum(
  "securities.transactional.datafeed.v1.Top20Type",
  [
    {no: 0, name: "TOP20_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 2, name: "TOP20_TYPE_FREQUENCY_RG", localName: "FREQUENCY_RG"},
    {no: 5, name: "TOP20_TYPE_PERCENTAGE_GAINER_RG", localName: "PERCENTAGE_GAINER_RG"},
    {no: 6, name: "TOP20_TYPE_PERCENTAGE_LOSER_RG", localName: "PERCENTAGE_LOSER_RG"},
  ],
);

/**
 * @generated from enum securities.transactional.datafeed.v1.ErrorCode
 */
export const ErrorCode = /*@__PURE__*/ proto3.makeEnum(
  "securities.transactional.datafeed.v1.ErrorCode",
  [
    {no: 0, name: "ERROR_CODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 400, name: "ERROR_CODE_BAD_REQUEST", localName: "BAD_REQUEST"},
    {no: 401, name: "ERROR_CODE_UNAUTHORIZED", localName: "UNAUTHORIZED"},
  ],
);

/**
 * @generated from enum securities.transactional.datafeed.v1.TradeType
 */
export const TradeType = /*@__PURE__*/ proto3.makeEnum(
  "securities.transactional.datafeed.v1.TradeType",
  [
    {no: 0, name: "TRADE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TRADE_TYPE_BUY", localName: "BUY"},
    {no: 2, name: "TRADE_TYPE_SELL", localName: "SELL"},
  ],
);

/**
 * @generated from message securities.transactional.datafeed.v1.Bid
 */
export const Bid = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.v1.Bid",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "lot", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.v1.Offer
 */
export const Offer = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.v1.Offer",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "lot", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.v1.Change
 */
export const Change = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.v1.Change",
  () => [
    { no: 1, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.v1.Error
 */
export const Error = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.v1.Error",
  () => [
    { no: 1, name: "code", kind: "enum", T: proto3.getEnumType(ErrorCode) },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

